//Lista dos nomes dos ícones do popover do componente EpButtonVision de acordo com o tipo de acesso do usuário
export enum IconNamesByRoleEnum {
  'account-manager' = 'SolidHospitalAlt',
  'network-manager' = 'SolidSitemap',
  'hospital-manager' = 'SolidHospital',
  'segment-manager' = 'ShareAlt',
}

export enum HospitalStructureLevels {
  WithoutStructure = 0,
  Tenant = 1,
  Network = 2,
  Segment = 3,
  Hospital = 4,
  Department = 5,
  Unit = 6,
}
